export default "/static/dashboard/build/app/img/v2/754091143ff7cfcf25aef1dd39f4fdd8.png";